module.exports = __webpack_public_path__ + "media/images/pic03-d2607b7c3289da9001b9c07f85464f82.jpg";